<template>
  <v-row>
    <v-col cols="12">
      <!-- fast kpis -->
      <v-row>
        <v-col cols="4">
          <metric-kpi metric="expired-supporting-documents" interval="yearly" comparative="this_v_last_mtd" />
        </v-col>
        <v-col cols="4">
          <metric-kpi metric="unused-supporting-documents" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="4">
          <metric-kpi metric="unprocessed-subscriptions" interval="monthly" comparative="this_v_last" />
        </v-col>
      </v-row>
      <!-- end fast kpis -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Documentos de soporte <piriod-beta-label element="Chip" feature="SupportingDocuments" /></v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="supporting-document" class="mr-1 ml-1" />
              <v-btn @click="dialogCreate=true" outlined color="secondary"><v-icon left small>mdi-plus</v-icon>Importar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <supporting-document-list :show-create="true" />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog new supporting document -->
    <v-dialog v-model="dialogCreate" no-click-animation persistent scrollable width="600">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Importar documento de soporte</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCreate=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-2">
              <v-list-item-content>
                <!-- :error="valid" -->
                <v-file-input v-model="newImport.file" class="v-file-input-dropzone" accept=".pdf" chips flat hide-details placeholder="Seleccionar un archivo PDF" prepend="mdi-paper-clip" solo type="file" />
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n4">
              <v-list-item-title class="text--secondary font-weight-medium">Cliente</v-list-item-title>
              <v-list-item-subtitle class="pl-1" v-if="!newImport.customer.id">
                <v-col cols="8">
                  <v-btn @click="dialogCustomer=true" outlined :ripple="false"><v-icon left>mdi-plus</v-icon>Seleccionar un cliente</v-btn>
                </v-col>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else>
                <v-list class="transparent">
                  <v-list-item class="pa-0">
                    <v-list-item-subtitle class="py-1">
                      <v-row no-gutters align="center">
                        <v-col cols="6">
                          <span class="body-2 text--secondary font-weight-medium">{{newImport.customer.name}}</span>
                        </v-col>
                        <v-col cols="6" class="pl-2">
                          <v-btn @click="dialogCustomer=true" outlined color="secondary">Seleccionar otro...</v-btn>
                        </v-col>
                      </v-row>
                      </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title class="text--secondary font-weight-medium">Tipo de factura</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.newImport.document_type.$model" :error="$v.newImport.document_type.$error" :items="supportingDocumentTypes" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details>
                    <template v-slot:item="data">
                      <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title class="text--secondary font-weight-medium">Fecha</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-menu v-model="datePickers.dateIssued" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.newImport.date_issued.$model" :error="$v.newImport.date_issued.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.newImport.date_issued.$model" @input="datePickers.dateIssued=false" type="date" :min="today" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title>
                      <v-row class="py-2 px-6" align="center" justify="end">
                        <v-btn @click="() => { $v.newImport.date_issued.$model=today; datePickers.dateIssued=false }" color="primary">Hoy</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-list-item-subtitle>
              </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title class="text--secondary font-weight-medium">Válido hasta</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-menu v-model="datePickers.validUntil" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.newImport.valid_until.$model" :error="$v.newImport.valid_until.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.newImport.valid_until.$model" @input="datePickers.validUntil=false" type="date" :min="today" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title>
                      <v-row class="py-2 px-6" align="center" justify="end">
                        <v-btn @click="() => { $v.newImport.valid_until.$model=today; datePickers.validUntil=false }" color="primary">Hoy</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn @click="dialogCreate=false" outlined>Cancelar</v-btn>
          <v-spacer />
          <v-btn @click="createImport" :loading="$store.state.supportingDocuments.createLoader" color="primary">Importar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog supporting document -->

    <!-- dialog customer -->
    <v-dialog v-model="dialogCustomer" width="600" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="60">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon retain-focus-on-click :ripple="false" small @click="dialogCustomer=false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-col class="py-2">
                <v-text-field v-model="customerQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un cliente..." hide-details/>
              </v-col>
              <v-divider />
              <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" :loading="$store.state.customers.retrieveLoader" type="list-item"></v-skeleton-loader>
              <template v-else>
                <template v-if="customersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in customersList" :key="d.id" @click="setCustomer(d)" style="cursor: pointer">
                          <td>
                            <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen clientes</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog customer -->

  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { supportingDocumentsFilters } from '@/collections/queryBuilderFilters'

import ListViewMixin from '@/mixins/ListViewMixin'

import MetricKpi from '@/components/reports/MetricKpi'
import PiriodBetaLabel from '@/components/ux/PiriodBetaLabel'
import SupportingDocumentList from '@/components/supporting-documents/SupportingDocumentList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableSettings from '@/components/VTable/VTableSettings'

export default {
  components: {
    MetricKpi,
    PiriodBetaLabel,
    SupportingDocumentList,
    VQueryBuilder,
    VTableSettings
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    collapsePayment: false,
    customerQuery: '',
    dialogCustomer: false,
    filters: supportingDocumentsFilters,
    datePickers: {
      dateIssued: false,
      validUntil: false
    },
    newImport: {
      customer: '',
      date_issued: '',
      document_type: '',
      valid_until: null
    },
    supportingDocumentTypes: [
      { id: '801', name: 'Orden de compra' },
      { id: '802', name: 'Contrato' }
    ]
  }),
  computed: mapState({
    customersList: state => state.customers.customersList
  }),
  watch: {
    customerQuery () {
      this.debounceMethod(this.getCustomers)
    },
    dialogCustomer () {
      if (this.dialogCustomer) {
        this.getCustomers()
      }
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('supportingDocuments/LIST', {
        resource: 'supporting-documents/documents',
        query: {
          ...this.$route.query,
          expand: 'customer'
        }
      })
    },
    createImport () {
      this.$v.newImport.$touch()

      if (this.$v.newImport.$invalid) {
        return false
      }

      const payload = new FormData()
      payload.append('customer', this.newImport.customer.id)
      payload.append('document_type', this.newImport.document_type)
      payload.append('date_issued', this.newImport.date_issued)
      payload.append('file', this.newImport.file)
      payload.append('valid_until', this.newImport.valid_until)

      this.$store.dispatch('supportingDocuments/CREATE', {
        resource: 'supporting-documents/documents',
        payload: payload,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        this.getList()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    getCustomers () {
      if ([1, 2].includes(this.customerQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.customerQuery.length >= 3) {
        query.name__icontains = this.customerQuery.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: query
      })
    },
    setCustomer (customer) {
      this.newImport.customer = customer
      this.customerQuery = ''
      this.dialogCustomer = false
    }
  },
  validations: {
    newImport: {
      document_type: {
        required
      },
      date_issued: {
        required
      },
      valid_until: {
        required
      }
    }
  }
}
</script>